import {Model} from '@/models/Model'
import {DataOrdersArray} from '@/models/Order'
import {OrderUser} from '@/models/OrderUser'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const UserConst = Object.freeze({
  ROLE_ADMIN: 1,
  ROLE_CEO: 2,
  ROLE_DIRECTOR: 5,
  ROLE_MANAGER: 10,
  ROLE_ACCOUNT: 15,
  ROLE_MARKETING: 16,
  ROLE_LOGISTIC: 17,
  ROLE_DRIVER: 18,
  ROLE_EXTERNAL: 19,
  ROLE_USER: 20,
  ROLE_STOCK: 21,

  map(status: number): string {
    switch (status) {
      case UserConst.ROLE_ADMIN:
        return 'Admin'
      case UserConst.ROLE_CEO:
        return 'CEO'
      case UserConst.ROLE_DIRECTOR:
        return 'Director'
      case UserConst.ROLE_MANAGER:
        return 'Manager'
      case UserConst.ROLE_ACCOUNT:
        return 'Account'
      case UserConst.ROLE_MARKETING:
        return 'Marketing'
      case UserConst.ROLE_LOGISTIC:
        return 'Logistic'
      case UserConst.ROLE_DRIVER:
        return 'Driver'
      case UserConst.ROLE_EXTERNAL:
        return 'External'
      case UserConst.ROLE_USER:
        return 'Sale'
      case UserConst.ROLE_STOCK:
        return 'Stock'

      //รอจัดทริป
      //กำลังขนส่ง
      //
    }
    // debugger
    return ''//'ไม่ระบุ[' + status + ']'
  },
})


export class User extends Model {
  declare id: number | null
  username: string |null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  nickname: string | null
  employee_code: string | null
  picture: string | null
  signature: string | null
  tel: string | null
  department: string | null
  role: number | null
  password: string | null
  theme: string | null
  mode: string | null
  target_sale: number | null

  orderUser: OrderUser | null

  enabled: boolean | null
  parent_id: number | null

  approving_credit: number | null
  approving_invoices: number | null

  getResourceURL(): string {
    return Helper.setting.user.getResourceAPI
  }


  public async loadOrders(): Promise<DataOrdersArray> {
    console.log('User load order')
    return await new Promise<DataOrdersArray>((resolve, reject) => {
      Helper.get(Helper.setting.user.getOrderAPI.replace('{id}', this.id))
        .then<{ data: DataOrdersArray }>(({data}) => resolve(data))
        .catch((e) => reject(e))
    })
  }

}

export class DataUsersArray extends DataArray {

  declare data: User[]
  filter: FilterUser = new FilterUser()
}


export class FilterUser {

  department: FilterSet = new FilterSet()
  role: FilterSet = new FilterSet()
}


export class DataUser extends DataResource {

  declare data: User

}
